<div align="end">
  <i *ngIf="customUrl || userCard.name || userCard.surname || userCard.specialization" (click)="closeDialog()"
     class="material-icons clear-icon">clear</i>
</div>
<div class="content-center">
  <div class="qr-content">
    <div class="model">
      <img [src]="qrCode" alt="QR Code" class="qr-code-image">
    </div>
    <div *ngIf="userCard.name || userCard.surname || userCard.specialization || userCard.company">
      <p class="qr-content info ">{{ userCard.name }} {{ userCard.surname }}</p>
      <span class="mb-1 specialization-p font">{{ userCard.specialization }} <span
        *ngIf="userCard.specialization && userCard.company">•</span> {{ userCard.company }}</span>
    </div>
    <div class="button">
      <button class="share mt-3 mb-1" (click)="shareLink()">{{ 'cards_by_qr.share' | translate }}</button>

      <div class="modal-footer">
        <button class="btn download" (click)="isFromUserCardPaymentPage() ? copyPaymentLinkToClipboard() : copyLinkToClipboard()">
        <span>{{ 'qr_modal.copy_card_link' | translate }}</span>
        </button>
        <button class="btn download" (click)="saveImage()">
          <span>{{ 'qr_modal.download_qr' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
